module.exports = __webpack_public_path__ + "img/profile-man-6-min.f83e6b9d.jpg";